import React, { useEffect, useRef } from 'react';
import './detection.scss';

import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import {
  getJsonFromStorage,
  getPaginationOpts,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { loadDetectionList } from '../actions';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import { getDetectionData } from '../reducer';
import { getCamerasData } from '../../Settings/reducer';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../components/base/Pagination/Pagination';
import { dateTimeFormatter, regNumberFormatter, tooltipFormatter } from '../../../utils/formatters';

export default function DetectionPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const { updatePeriod } = useSelector(getSystemData);
  const {
    loadingList,
    list = [],
    listMeta = {},
  } = useSelector(getDetectionData);
  const { cameraList = [] } = useSelector(getCamerasData);
  const intl = useIntl();
  const { formatMessage } = intl;
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(listMeta, opts);
    const requestData = {
      ...paginationOpts,
      reverse_order: true,
      // filter: filterData,
      // sort: sortData.join(','),
    };
    const p1 = dispatch(loadDetectionList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const defaultFilterValues = {
    find: '',
    date: '',
    date_start: '',
    date_end: '',
    type: '',
    reg_number: '',
    show_conditionally_recognized: false,
    car_type: '',
    camera: '',
    zone: '',
  };

  const {
    register, getValues, watch, setValue, reset,
  } = useForm({
    defaultValues: getJsonFromStorage('system-events-filter') || { ...defaultFilterValues },
  });

  const cameraFormatter = id => {
    const camera = cameraList.find(f => f.id === id);
    return camera && camera.name ? camera.name : id;
  };

  const detectionColumns = [
    {
      dataField: 'detection_time',
      text: formatMessage({ id: 'car.detection.time' }),
      formatter: dateTimeFormatter,
      headerClassName: 'date-column',
      disableSort: true,
    },
    {
      dataField: 'lp_text',
      text: formatMessage({ id: 'reg_number.short' }),
      formatter: regNumberFormatter,
      headerClassName: 'reg-number-column',
      disableSort: true,
    },
    {
      dataField: 'camera_id',
      text: formatMessage({ id: 'camera' }),
      formatter: cameraFormatter,
      headerClassName: 'camera-column',
      disableSort: true,
    },
    {
      dataField: 'zone_name',
      text: formatMessage({ id: 'zone' }),
      formatter: tooltipFormatter,
      headerClassName: 'zone-column',
      disableSort: true,
    },
    {
      dataField: 'tour_id',
      text: formatMessage({ id: 'tour' }),
      formatter: tooltipFormatter,
      headerClassName: 'tour-column',
      disableSort: true,
    },
  ];

  const meta = {};

  return (
    <div className="page session-page">
      <Loader loading={loadingList} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.detection' })}</div>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid data={list} columns={detectionColumns} name="detection-list" />
            </div>
          </div>
          <Pagination meta={listMeta} list={list} handleChangeMeta={loadData} />
        </div>
      </div>
    </div>
  );
}
